import React from 'react';
import PropTypes from 'prop-types';

import { CHANGEABLE_CATEGORIES } from 'constants/outfits';
import ProfileContext from 'components/Profile/ProfileContext';
import ProfileInventoryItemComponent from './ProfileInventoryItemComponent';

export default function ProfileInventoryItemContainer({ data }) {
  const { category } = data;
  return (
    <ProfileContext.Consumer>
      {({ editable, profileCharacter }) => (
        <ProfileInventoryItemComponent
          data={data}
          editable={editable && CHANGEABLE_CATEGORIES.indexOf(category) >= 0}
          profileCharacter={profileCharacter}
        />
      )}
    </ProfileContext.Consumer>
  );
}

ProfileInventoryItemContainer.displayName = 'ProfileInventoryItemContainer';

ProfileInventoryItemContainer.propTypes = {
  data: PropTypes.shape({}).isRequired,
};